"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7486],{

/***/ 64001:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/GromoLogo.f6c2f6dc.svg","height":152,"width":452});

/***/ }),

/***/ 75355:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/playStoreBlack.82b17a51.svg","height":48,"width":162});

/***/ }),

/***/ 7486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AppNavBar; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Drawer/Drawer.js + 2 modules
var Drawer = __webpack_require__(77533);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Menu.js
var Menu = __webpack_require__(326);
// EXTERNAL MODULE: ./public/assets/images/home/GromoLogo.svg
var GromoLogo = __webpack_require__(64001);
;// CONCATENATED MODULE: ./public/assets/images/home/PlayStoreIconOnly.svg
/* harmony default export */ var PlayStoreIconOnly = ({"src":"/_next/static/media/PlayStoreIconOnly.0c229579.svg","height":24,"width":22});
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(94253);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(69417);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(50594);
// EXTERNAL MODULE: ./utils/Utils.ts
var Utils = __webpack_require__(2619);
// EXTERNAL MODULE: ./utils/ImageExport.ts + 6 modules
var ImageExport = __webpack_require__(80645);
// EXTERNAL MODULE: ./utils/Constants.ts
var Constants = __webpack_require__(40953);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/AppNavBar.tsx















function AppNavBar(param) {
    let { navBgColor  } = param;
    var ref;
    const router = (0,next_router.useRouter)();
    const [drawerOpen, setDrawerOpen] = (0,react.useState)(false);
    const [imgSrc, setImgSrc] = (0,react.useState)();
    const [downloadBtn, setDownloadBtn] = (0,react.useState)(false);
    const [showIcon, setShowIcon] = (0,react.useState)(false);
    const [selectedItem, setSelectedItem] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        const handleResize = ()=>{
            var ref;
            if (((ref = globalThis.window) === null || ref === void 0 ? void 0 : ref.location.pathname) !== "/") {
                var ref1;
                setShowIcon(true);
                setDownloadBtn(true);
                setImgSrc(((ref1 = Utils/* default.getOS */.Z.getOS()) === null || ref1 === void 0 ? void 0 : ref1.toLocaleLowerCase()) === "android" ? ImageExport/* PLAYSTORE_BLACK */.ZE : undefined);
            } else {
                setDownloadBtn(true);
            }
        };
        const handleScroll = ()=>{
            var ref;
            if (((ref = globalThis.window) === null || ref === void 0 ? void 0 : ref.location.pathname) === "/") {
                setShowIcon(globalThis.window.pageYOffset > 210);
            }
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        return ()=>{
            window.removeEventListener("resize", handleResize);
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    const RightDrawer = ()=>{
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Drawer/* default */.ZP, {
            anchor: "right",
            open: drawerOpen,
            onClose: ()=>setDrawerOpen(false),
            sx: {
                minWidth: "230px !important"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    sx: {
                        width: "100%",
                        padding: "15px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        borderBottom: "1px solid #0000001a",
                        height: "56px"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                width: "100px",
                                height: "35px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: GromoLogo/* default */.Z,
                                    alt: "gromoLogo",
                                    width: 100,
                                    height: 100,
                                    style: {
                                        objectFit: "contain"
                                    },
                                    loading: "lazy"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            onClick: ()=>setDrawerOpen(false),
                            paddingRight: "18px",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                                sx: {
                                    color: "#212736"
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    width: "100%",
                    sx: {
                        width: "100%",
                        color: "#0A0C0F"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        style: {
                            listStyleType: "none",
                            padding: 0,
                            margin: 0
                        },
                        children: [
                            [
                                {
                                    name: "Sell Insurance",
                                    link: "https://www.gromoinsure.in/"
                                },
                                {
                                    name: "Apply for Products",
                                    link: "/customer"
                                },
                                {
                                    name: "Careers",
                                    link: "/careers"
                                },
                                {
                                    name: "About us",
                                    link: "/about-us"
                                },
                                {
                                    name: "Blogs",
                                    link: "https://gromo.in/blog/"
                                },
                                {
                                    name: "FinArva AI",
                                    link: "/finarva-ai"
                                }
                            ].map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    style: {
                                        margin: "8px 0"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: item.link,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "h6",
                                            component: "div",
                                            fontSize: "16px",
                                            padding: "0 16px",
                                            sx: {
                                                background: selectedItem === item.name ? "lightgrey" : "white",
                                                display: "block",
                                                textDecoration: "none",
                                                color: "inherit"
                                            },
                                            onClick: ()=>setSelectedItem(item.name),
                                            children: item.name
                                        })
                                    })
                                }, item.name)),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                style: {
                                    margin: "8px 0"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h6",
                                    component: "div",
                                    fontSize: "16px",
                                    padding: "0 16px",
                                    onClick: ()=>{
                                        var ref;
                                        setDrawerOpen(false);
                                        window.scroll(0, document === null || document === void 0 ? void 0 : (ref = document.body) === null || ref === void 0 ? void 0 : ref.scrollHeight);
                                    },
                                    sx: {
                                        display: "block",
                                        textDecoration: "none",
                                        color: "inherit"
                                    },
                                    children: "Contact us"
                                })
                            })
                        ]
                    })
                })
            ]
        });
    };
    const pushToPage = (name, redirectionLink)=>{
        if (name === "Blogs") {
            window.open("https://gromo.in/blog/", "_blank");
        } else {
            router.push(redirectionLink);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        sx: {
            height: {
                xs: "56px",
                md: "73px"
            },
            width: "100%",
            position: "fixed",
            zIndex: 20,
            top: 0,
            borderBottom: "1px solid #EAF0FF24",
            boxShadow: navBgColor === "#002561" ? "0px 0px 4px rgba(0, 0, 0, 0.15)" : ""
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            sx: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                height: "100%",
                padding: "0px 15px",
                background: navBgColor || "#002561",
                color: navBgColor === "#002561" ? "black" : "#002561",
                transition: "background 1s ease"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    sx: {
                        display: {
                            xs: "block",
                            md: "none",
                            display: "flex",
                            alignItems: "center"
                        },
                        width: "100px",
                        height: "100%",
                        justifyContent: "center",
                        alignItems: "center"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            width: 100,
                            height: 100,
                            src: navBgColor === "white" ? ImageExport/* GROMOLOGO_WHITE */.un : ImageExport/* GROMOLOGO_WHITE */.un,
                            alt: "GromoLogo",
                            loading: "lazy",
                            style: {
                                objectFit: "contain",
                                marginTop: "14px"
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    sx: {
                        display: {
                            xs: "none",
                            md: "flex"
                        },
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            sx: {
                                paddingLeft: "3%",
                                width: "150px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    width: 100,
                                    height: 100,
                                    src: navBgColor === "white" ? GromoLogo/* default */.Z : ImageExport/* GROMOLOGO_WHITE */.un,
                                    alt: "GromoLogo",
                                    style: {
                                        objectFit: "contain"
                                    },
                                    loading: "lazy"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            sx: {
                                display: {
                                    xs: "none",
                                    md: "flex"
                                },
                                justifyContent: "space-around",
                                alignItems: "center",
                                listStyle: "none",
                                width: "150%",
                                cursor: "pointer",
                                fontSize: "16px",
                                padding: navBgColor === "white" ? "0" : "10px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                style: {
                                    listStyleType: "none",
                                    display: "flex",
                                    padding: 0,
                                    margin: 0
                                },
                                children: [
                                    [
                                        {
                                            name: "Sell Insurance",
                                            link: "https://www.gromoinsure.in/"
                                        },
                                        {
                                            name: "Apply for Products",
                                            link: "/customer"
                                        },
                                        {
                                            name: "Careers",
                                            link: "/careers"
                                        },
                                        {
                                            name: "About us",
                                            link: "/about-us"
                                        },
                                        {
                                            name: "Blogs",
                                            link: "https://gromo.in/blog/"
                                        },
                                        {
                                            name: "FinArva AI",
                                            link: "/finarva-ai"
                                        }
                                    ].map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            style: {
                                                padding: "4px",
                                                minWidth: "fit-content",
                                                margin: "auto auto auto 32px"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                onClick: ()=>pushToPage(item.name, item.link),
                                                style: {
                                                    margin: "auto",
                                                    color: navBgColor === "white" ? "#393F50" : "white"
                                                },
                                                children: item.name
                                            })
                                        }, item.name)),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        style: {
                                            width: "105px",
                                            height: "40px",
                                            margin: "auto auto auto 32px",
                                            display: "flex",
                                            alignItems: "center"
                                        },
                                        onClick: ()=>{
                                            var ref;
                                            setDrawerOpen(false);
                                            window.scroll(0, document === null || document === void 0 ? void 0 : (ref = document.body) === null || ref === void 0 ? void 0 : ref.scrollHeight);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            style: {
                                                margin: "auto",
                                                color: navBgColor === "white" ? "#393F50" : "white"
                                            },
                                            children: "Contact us"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    sx: {
                        display: {
                            xs: "none",
                            md: "flex"
                        },
                        justifyContent: "right",
                        alignItems: "center",
                        listStyle: "none",
                        width: "35%",
                        padding: "10px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        style: {
                            listStyleType: "none",
                            display: "flex",
                            alignItems: "center",
                            padding: "5px",
                            marginTop: "10px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                style: {
                                    padding: "5px",
                                    color: navBgColor === "white" ? "#393F50" : "white"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: Constants/* appLink */.ze,
                                    children: "Download"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                style: {
                                    height: "40px",
                                    width: "40px",
                                    background: navBgColor === "#002561" ? navBgColor : "black",
                                    borderRadius: "8px",
                                    padding: "5px",
                                    cursor: "pointer",
                                    margin: "5px 16px",
                                    border: navBgColor === "#002561" ? "1px solid #D4DFFF" : "none",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: Constants/* appLink */.ze,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        width: 100,
                                        height: 100,
                                        src: PlayStoreIconOnly,
                                        alt: "appStoreIcon",
                                        style: {
                                            objectFit: "contain"
                                        }
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    sx: {
                        display: [
                            "block",
                            "block",
                            "none"
                        ]
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            href: Constants/* appLink */.ze,
                            sx: {
                                color: "white",
                                marginRight: "24px",
                                background: ((ref = globalThis.window) === null || ref === void 0 ? void 0 : ref.screen.availWidth) < 500 ? "#268BF0" : "transparent",
                                padding: downloadBtn ? "0 8px" : "0"
                            },
                            children: downloadBtn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h6",
                                textTransform: "none",
                                fontSize: 16,
                                children: "Download"
                            }) : showIcon ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: imgSrc,
                                alt: "download link",
                                style: {
                                    objectFit: "contain"
                                },
                                width: 100,
                                height: 40,
                                loading: "eager",
                                priority: true
                            }) : null
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                            sx: {
                                color: {
                                    xs: "white",
                                    md: navBgColor === "#002561" ? "black" : "white"
                                },
                                marginRight: "18px",
                                fontSize: "24px"
                            },
                            onClick: ()=>setDrawerOpen(true)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RightDrawer, {})
            ]
        })
    });
}


/***/ }),

/***/ 40953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gv": function() { return /* binding */ NUMBER_OF_DOWNLOADS; },
/* harmony export */   "ze": function() { return /* binding */ appLink; }
/* harmony export */ });
/* unused harmony export NavHeight */
const NUMBER_OF_DOWNLOADS = 40;
const NavHeight = 72;
const appLink = "https://gromo.co.in/XKiY";


/***/ }),

/***/ 80645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "un": function() { return /* binding */ GROMOLOGO_WHITE; },
  "ZE": function() { return /* binding */ PLAYSTORE_BLACK; }
});

// UNUSED EXPORTS: APPSTORE_BLACK, APPSTORE_WHITE, CURVEDOWN, CURVEUP, PLAYSTORE_WHITE

;// CONCATENATED MODULE: ./public/assets/images/home/GromologoWhite.svg
/* harmony default export */ var GromologoWhite = ({"src":"/_next/static/media/GromologoWhite.e40777f3.svg","height":152,"width":453});
// EXTERNAL MODULE: ./public/assets/images/home/playStoreBlack.svg
var playStoreBlack = __webpack_require__(75355);
;// CONCATENATED MODULE: ./public/assets/images/home/appStoreBlack.svg
/* harmony default export */ var home_appStoreBlack = ({"src":"/_next/static/media/appStoreBlack.83e4404f.svg","height":48,"width":144});
;// CONCATENATED MODULE: ./public/assets/images/home/curveUp.webp
/* harmony default export */ var home_curveUp = ({"src":"/_next/static/media/curveUp.28d658e0.webp","height":128,"width":581,"blurDataURL":"data:image/webp;base64,UklGRlYAAABXRUJQVlA4WAoAAAAQAAAABwAAAQAAQUxQSBEAAAAABgoKCgoKDA0EAAAAAAAAAABWUDggHgAAAHABAJ0BKggAAgACQDglnAJ0AYhAAP76rFXTvgAAAA==","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./public/assets/images/home/curveDown.webp
/* harmony default export */ var home_curveDown = ({"src":"/_next/static/media/curveDown.e6c43b1f.webp","height":128,"width":581,"blurDataURL":"data:image/webp;base64,UklGRlYAAABXRUJQVlA4WAoAAAAQAAAABwAAAQAAQUxQSBEAAAAABAAAAAAAAAAGCgoKCgoMDQBWUDggHgAAAHABAJ0BKggAAgADADglnAJ0AYhAAP76fuQhs5KgAA==","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./public/assets/images/home/playStoreWhite.svg
/* harmony default export */ var home_playStoreWhite = ({"src":"/_next/static/media/playStoreWhite.1e565680.svg","height":48,"width":162});
;// CONCATENATED MODULE: ./public/assets/images/home/appStoreWhite.svg
/* harmony default export */ var home_appStoreWhite = ({"src":"/_next/static/media/appStoreWhite.d6b87b91.svg","height":48,"width":144});
;// CONCATENATED MODULE: ./utils/ImageExport.ts







const GROMOLOGO_WHITE = GromologoWhite;
const PLAYSTORE_BLACK = playStoreBlack/* default */.Z;
const APPSTORE_BLACK = (/* unused pure expression or super */ null && (appStoreBlack));
const CURVEDOWN = (/* unused pure expression or super */ null && (curveDown));
const CURVEUP = (/* unused pure expression or super */ null && (curveUp));
const PLAYSTORE_WHITE = (/* unused pure expression or super */ null && (playStoreWhite));
const APPSTORE_WHITE = (/* unused pure expression or super */ null && (appStoreWhite));


/***/ }),

/***/ 2619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _class; }
/* harmony export */ });
class _class {
    static getOS() {
        var uA = navigator.userAgent || navigator.vendor;
        if (uA.includes("Mac") && "ontouchend" in document) return "iOS";
        var i, os = [
            "Windows",
            "Android",
            "Unix",
            "Mac",
            "Linux",
            "BlackBerry"
        ];
        for(i = 0; i < os.length; i++)if (new RegExp(os[i], "i").test(uA)) return os[i];
    }
    static setTitle(title) {
        document.title = title;
    }
    static trackEvent(event, data) {
        try {
            const Moengage = window === null || window === void 0 ? void 0 : window.moe({
                app_id: "MALTTXFD391QLJ3UZNAD1ZH9",
                debug_logs: Number(0)
            });
            if (data && Object.keys(data).length) {
                Moengage.track_event(event, data);
                console.log("data", data);
            } else {
                Moengage.track_event(event);
            }
        } catch (error) {}
    }
    static setCookies(name, value, hours) {
        var expires = "";
        if (hours) {
            var date = new Date();
            date.setTime(date.getTime() + hours * 60 * 60 * 1000);
            expires = "; expires=" + date.toUTCString();
        }
        globalThis.window.document.cookie = name + "=" + (value || "") + expires + "; path=/; Secure";
    }
    static getCookie(name) {
        var ref, ref1, ref2;
        var nameEQ = name + "=";
        var ca = globalThis === null || globalThis === void 0 ? void 0 : (ref = globalThis.window) === null || ref === void 0 ? void 0 : (ref1 = ref.document) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.cookie) === null || ref2 === void 0 ? void 0 : ref2.split(";");
        for(var i = 0; i < (ca === null || ca === void 0 ? void 0 : ca.length); i++){
            var c = ca[i];
            while(c.charAt(0) == " ")c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
    static removeCookie(name) {
        globalThis.window.document.cookie = name + "=; path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    }
}



/***/ })

}]);